import React, {useContext} from 'react';
import NavLink from "../NavLink.react";
import styled from "styled-components";
import AppContext from "../../../Context/AppContext.react";

const StyledLeftNav = styled.div`
 .brand-logo {
    padding-right: 1.4rem;
    display: flex;
    align-items: center;
    img {
      width: 4rem;
      margin-left: 2rem;
      margin-top: 1rem;
    }
 }

  .nav-items {
    display: flex;
    align-items: center;
    padding-bottom: 1rem;
    padding-left: 2rem;
    
    a {
      font-size: 2rem;
      padding-right: 4rem;
      letter-spacing: 1px;
      color: #6C6C6C;
      :hover {
        color: #3388BD;
      }
    }
 }
`

const MainNavItems = ({permissions}) => {
  const showCustomers = permissions.includes('customer:view')
  const showCustomReports = permissions.includes('special::all')
  return (
    <StyledLeftNav>
      <div className="brand-logo">
        <a href={'/'}>
          <img src={'circle-logo.svg'}/>
        </a>
        <div className={'nav-items'}>
          <NavLink path={"/dashboard"} label={"Dashboard"} />
          <NavLink path={"/transactions"} label={"Transactions"} />
          {showCustomReports && <NavLink path={"/reports"} label={"Custom Reports"} />}
          {showCustomers && <NavLink path={"/customers"} label={"Customers"} />}
          <NavLink path={"/holdings"} label={"Holdings"} />
          <NavLink path={"/taxes"} label={"Taxes"} />
          <NavLink path={"/reports"} label={"Reports"} />
        </div>
      </div>
    </StyledLeftNav>
  )
}

export default MainNavItems;

